import { array, Decoder, number, object } from '@mojotech/json-type-validation'

import { problemDecoder } from '../problem/problemDecoder'

import { Bookmark } from '@/domain/value_objects/bookmark/bookmark'

export const bookmarkDecoder: Decoder<Bookmark> = object({
  progress: number(),
  numberOfProblems: number(),
  numberOfSolved: number(),
  problems: array(problemDecoder)
})
